'use client'

import { faChalkboardUser, faList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const changeTab = (e: any) => {
  let item = e.target.getAttribute('id')
  let content = document.getElementById('content-' + item)
  let tabs = document.getElementsByClassName('tab')
  let panes = document.getElementsByClassName('pane')

  for (let tab of tabs) {
    tab.classList.remove('tab-active')
  }

  for (let pane of panes) {
    pane.classList.remove('grid')
    pane.classList.add('hidden')
  }

  e.target.classList.add('tab-active')
  content?.classList.remove('hidden')
  content?.classList.add('grid')
}

export default function PanelGridDocente() {
  return (
    <div className="tabs justify-center md:px-10">
      <div
        className="tab tab-active tab-bordered min-h-[60px] w-1/2 text-xs uppercase lg:min-h-max lg:text-base"
        id="grade"
        onClick={changeTab}
      >
        <p className="pointer-events-none">
          <FontAwesomeIcon
            icon={faList}
            width={20}
            className="mr-1 w-8 !bg-transparent"
          />
          Grade curricular
        </p>
      </div>

      <div
        className="tab tab-bordered min-h-[60px] w-1/2 text-xs uppercase lg:min-h-max lg:text-base"
        id="docente"
        onClick={changeTab}
      >
        <p className="pointer-events-none">
          <FontAwesomeIcon
            icon={faChalkboardUser}
            width={20}
            className="mr-3 w-8 !bg-transparent"
          />
          Corpo docente
        </p>
      </div>
    </div>
  )
}
